import { ReactNode } from 'react'
import sharedStyles from '../../landing-feature-store-hub.module.css'
import styles from './content-with-image-section.module.css'
import {
  StoryblokImage,
  getStoryblokImageServiceUrl,
} from '@cinch-nx/data-storyblok'
import { Heading } from '@cinch-labs/design-system'

export interface ContentWithImageSectionProps {
  title: string
  body: ReactNode
  image: StoryblokImage
}

export const ContentWithImageSection = ({
  title,
  body,
  image,
}: ContentWithImageSectionProps) => {
  const { filename, alt } = image
  const imageUrl = getStoryblokImageServiceUrl(filename, {
    filters: [{ quality: 70 }],
  })
  return (
    <section className={styles.sectionWrapper}>
      <div>
        <Heading className={sharedStyles.title}>{title}</Heading>
        <div>{body}</div>
      </div>

      <img
        src={imageUrl}
        alt={alt ? alt : ''}
        className={styles.sectionImage}
      />
    </section>
  )
}
